<template>
<div>
    <component :is="component"></component>
</div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { component } from 'vue/types/umd';
import { split_namespace_name } from '@/common';

export interface IShimmyPage {
  id: number;
  name: string;
  site_group_namespace: string;
  component: string;
  icon: string;
  user_type_permission: string;
}

export const shimmyPages: Map<string, IShimmyPage> =  new Map([
    // ['1',  {id: 1, name: 'Technical', site_group_namespace: 'prototype', component: './ventive/Landlord', icon: 'mdi-account-supervisor', user_type_permission: 'contractor'}],
    ['2',  {id: 2, name: 'Resident', site_group_namespace: 'ventive', component: './ventive/Resident', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['3',  {id: 3, name: 'Resident Shp6', site_group_namespace: 'ventive_shp6', component: './ventive_shp6/Resident', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['4',  {id: 4, name: 'Resident St Modwen', site_group_namespace: 'st_modwen_heathy_wood', component: './st_modwen/Resident', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],

    // ['3',  {id: 3, name: 'Fleet Manager', site_group_namespace: 'prototype',
    //    component: './ventive/VentiveFleetManager', icon: 'mdi-account-supervisor', user_type_permission: 'contractor'}],
    // ['4',  {id: 4, name: 'Pod Details', site_group_namespace: 'ventive',
    // component: './ventive/VentiveFleetManagerDetails', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['5',  {id: 5, name: 'Dashboard', site_group_namespace: 'carnego', component: './default/DashBoard', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['6',  {id: 6, name: 'Comfort', site_group_namespace: 'carnego', component: './default/Comfort', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['7',  {id: 7, name: 'Electricity', site_group_namespace: 'carnego', component: './default/ElectricityUsage', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['8',  {id: 8, name: 'Hotwater', site_group_namespace: 'carnego', component: './default/HotWaterUsage', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['9',  {id: 9, name: 'Dashboard', site_group_namespace: 'bryn_bragl', component: './default/DashBoard', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['10',  {id: 10, name: 'Comfort', site_group_namespace: 'bryn_bragl', component: './default/Comfort', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['11',  {id: 11, name: 'Electricity', site_group_namespace: 'bryn_bragl',
        component: './default/ElectricityUsage', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
    ['12',  {id: 12, name: 'Hotwater', site_group_namespace: 'bryn_bragl', component: './default/HotWaterUsage', icon: 'mdi-account-supervisor', user_type_permission: 'any'}],
]);

export function get_shimmy_pages_for_project(site_group_namespace: string): IShimmyPage[] {

    const tmp: IShimmyPage[] = [];

    console.log('getting shimmy pages for project: ', site_group_namespace);

    for (const v of shimmyPages.values()) {
        const namespace_name = split_namespace_name(site_group_namespace.toLowerCase());
        if (namespace_name === v.site_group_namespace.toLowerCase()) {
            tmp.push(v);
        }
    }

    return tmp;
}

@Component({
    components: {
    },
})
export default class ShimmyPlus extends Vue {

    private component: any = undefined;

    public async created() {
        this.update();
    }

    public async update() {

        const self  = this;

        const page_id = self.$route.params.id;

        const page: IShimmyPage | undefined = shimmyPages.get(page_id);

        if (page === undefined) {
            return;
        }

        self.component = () => import(`${page.component}.vue`);

        console.log("component: ", self.component, page.component);

        const userinfo = await this.$store.cache.dispatch('requestUserInfo');

        self.$forceUpdate();

        return;
    }

    @Watch('$route', { immediate: true, deep: true })
    public onUrlChange(newVal: any) {
        this.update();
    }

    public async mounted() {

        const self  = this;

        return;
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

html *
{
   font-family: Arial, Helvetica, sans-serif !important;
}

</style>